
<style scoped>
@import "./css/style.css";
</style>

<template>
  <div v-if="authenticated">
    <v-app>
      <Header
        :clipped="true"
        :drawer="false"
        :fixed="true"
        :title="title"
        ref="childComponent"
        v-if="showHeader"
      />

      <v-main>
        <search-menu :showSearchMenu="showSM" />
        <router-view />
      </v-main>
      <VersionModal v-model="showVersionModal" />
    </v-app>
  </div>
</template>
<script>
import Header from "./layout/header.vue";
import searchMenu from "./components/searchMenuComponent.vue";
import VersionModal from "./components/VersionModal.vue";
import { initVersionCheck } from "./services/versionCheck";

export default {
  name: "App",
  components: {
    Header,
    searchMenu,
    VersionModal,
  },

  data: () => ({
    title: process.env.VUE_APP_TITLE,
    authenticated: false,
    showVersionModal: false,
  }),

  async created() {
    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      this.authenticated = this.$GAUserAuth.user.isAuthenticated;
    });

    initVersionCheck(() => {
      this.showVersionModal = true;
    });
  },

  computed: {
    showSM: function () {
      return this.$store.getters.GET_showSearchMenu.show;
    },
    showHeader: function () {
      return this.$store.getters.GET_showHeader;
    },
  },

  methods: {},
};
</script>
